export default __webpack_public_path__ + "static/media/template_empty.1efba1d6.svg";